module.exports = __webpack_public_path__ + "img/LV.12cebcfb.svg";